import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import { checkPermissionForLevel } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';

class HamburgerStyles extends Component {
    constructor(props, context) {
        super(props);
        this.store = context.store;
    }

    render() {
        //metrics-proxies
        let widthFilter = new RemFilter(this.props.hamburgerMenu.width),
            iconSizeFilter = new RemFilter(this.props.hamburgerMenu.iconSize);
        return (
            <div className="HamburgerStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Icon Size"
                            onChange={this.props.onCssLengthChange('iconSize', iconSizeFilter)}
                            isDisabled={this.props.isDisabled}
                            defaultValue={iconSizeFilter.original.px.toString()}
                            values={this.props.availableFontSizes.map(v => {
                                return { key: v.toString(), label: v.toString() };
                            })}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Width"
                            onChange={this.props.onCssLengthChange('width', widthFilter)}
                            isDisabled={this.props.isDisabled}
                            defaultValue={widthFilter.original.px.toString()}
                            values={this.props.availableFontSizes.map(v => {
                                return { key: v.toString(), label: v.toString() };
                            })}
                        />
                    </div>
                    <div className="col-lg-4 col-xs-12 col-sm-4">
                        <div>Color</div>
                        <div className="row">
                            <div className="col-lg-4 col-xs-12 col-sm-4">
                                <PresetColorPicker
                                    color={this.props.hamburgerMenu.color.normal}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onThemePropChange('color.normal')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-xs-12 col-sm-4">
                        <div>Background</div>
                        <div className="row">
                            <BackgroundPicker
                                background={this.props.hamburgerMenu.background.normal}
                                preset={this.props.themeColors.primary.colors}
                                isDisabled={this.props.isDisabled}
                                onChange={property =>
                                    this.props.onThemePropChange('background.normal')({
                                        target: {
                                            value: property
                                        }
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HamburgerStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string,
    hamburgerMenu: PropTypes.object
};

HamburgerStyles.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.header[ownProps.tagName],
        ...state.theme.header,
        themeAccess: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        ),
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    const prefix = 'header.hamburgerMenu';
    return {
        onCssLengthChange: onCssLengthChange(dispatch, prefix),
        onThemePropChange: onThemePropChange(dispatch, prefix)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HamburgerStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/HamburgerStyles.js